var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 3873 3873",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 648.2,
    x2: 3228.8,
    y1: 652,
    y2: 3232.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc00ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00dbde"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "evenodd",
    d: "M3593.5 1044.6v234.7h-3310v-234.7c0-37.2 30.2-67.4 67.4-67.4h3175.2c37.2 0 67.4 30.2 67.4 67.4zM529 1370H283.5v228.7H529zM283.5 2840c0 37.2 30.2 67.4 67.4 67.4h3175.2c37.2 0 67.4-30.2 67.4-67.4V1689.4h-3310zm1281.7-167.7H502.9c-25 .1-45.3-20.2-45.3-45.3 0-25 20.3-45.3 45.3-45.3h1062.3c25 0 45.3 20.3 45.3 45.3s-20.3 45.3-45.3 45.3zm990.6-365c0-25 20.3-45.3 45.3-45.3h721.1c25 0 45.3 20.3 45.3 45.3v347.2c0 25-20.3 45.3-45.3 45.3h-721.1c-25 0-45.3-20.3-45.3-45.3zm-2052.9-17.9h1546c25 0 45.3 20.3 45.3 45.3s-20.3 45.3-45.3 45.3h-1546c-25 0-45.3-20.3-45.3-45.3s20.3-45.3 45.3-45.3zM619.7 1370v228.7h250.4V1370zm341.1 0v228.7h250.4V1370zm341 0v228.7h250.4V1370zm341 0v228.7h250.4V1370zm341.1 0v228.7h250.4V1370zm341 0v228.7h250.4V1370zm341.1 0v228.7h250.4V1370zm341 0v228.7h250.4V1370zm341 228.7h245.5V1370H3348zm-71.1 754h-630.4v256.5h630.4z",
    clipRule: "evenodd",
    opacity: 1,
    "data-original": "url(#a)",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.28d89b8c3336ab7989ae5e48a076b0a3.svg";
export { ForwardRef as ReactComponent };